<script lang="ts">
  import { route } from '../lib/router.svelte';
</script>

<section>
  <h2>Not found</h2>
  <p class="muted">The path <code>{route.current.path}</code> does not match a known view.</p>
  <p><a href="/dashboard">Return to the Dashboard</a></p>
</section>
